var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfileIconDynamic = function SvgProfileIconDynamic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "current",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50107 9.34695C12.0725 9.34695 14.1746 7.24492 14.1746 4.67348C14.1746 2.10203 12.0725 0 9.50107 0C6.92963 0 4.82764 2.10203 4.82764 4.67348C4.82764 7.24492 6.92967 9.34695 9.50107 9.34695Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5216 13.0816C17.3991 12.7755 17.2359 12.4898 17.0522 12.2245C16.1134 10.8367 14.6645 9.91835 13.0318 9.69386C12.8278 9.67346 12.6033 9.71425 12.44 9.83671C11.5828 10.4694 10.5625 10.7959 9.5012 10.7959C8.43995 10.7959 7.41956 10.4694 6.56241 9.83671C6.39913 9.71425 6.17464 9.65303 5.97058 9.69386C4.33792 9.91835 2.86855 10.8367 1.95019 12.2245C1.76651 12.4898 1.60323 12.7959 1.48081 13.0816C1.4196 13.2041 1.43999 13.3469 1.5012 13.4694C1.66448 13.7551 1.86855 14.0409 2.05222 14.2857C2.33792 14.6735 2.64405 15.0204 2.99101 15.3469C3.27671 15.6327 3.60323 15.898 3.9298 16.1633C5.54202 17.3674 7.48081 18 9.48081 18C11.4808 18 13.4196 17.3673 15.0318 16.1633C15.3584 15.9184 15.6849 15.6327 15.9706 15.3469C16.2971 15.0204 16.6237 14.6735 16.9094 14.2857C17.1135 14.0204 17.2972 13.7551 17.4604 13.4694C17.5624 13.3469 17.5828 13.2041 17.5216 13.0816Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileIconDynamic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-icon-dynamic.0709b9f3.svg";
export { ForwardRef as ReactComponent };